export const INITIAL_FILTER_STATE = {
  invoice_number: "",
  jobNo: "",
  customer: "",
  invoiceDateStart: null,
  invoiceDateEnd: null,
  deliveryDateStart: "",
  deliveryDateEnd: "",
  deliveredDateStart: null,
  deliveredDateEnd: null,
  driver_id: "",
  status: "",
};

export const fieldMappings = {
  jobNo: ["job_id", "$eq"],
  customer: ["customer", "$eq"],
  driver_id: ["driver_id", ""],
  invoice_number: ["invoice_number", "$eq"],
  status: ["delivery_status", "$eq"],
};

export const rangeFields = {
  orderDate: {
    apiField: "order_date",
    minField: "orderDateStart",
    maxField: "orderDateEnd",
  },
  deliveryDate: {
    apiField: "delivery_date",
    minField: "deliveryDateStart",
    maxField: "deliveryDateEnd",
  },
  invoiceDate: {
    apiField: "invoice_date",
    minField: "invoiceDateStart",
    maxField: "invoiceDateEnd",
  },
  deliveredDate: {
    apiField: "delivered_date",
    minField: "deliveredDateStart",
    maxField: "deliveredDateEnd",
  },
};

export const valueTransformers = {};

// Flat (non-"filters[field][$op]") query param builder used only by the
// driver-list based tabs (DriversPanel/DriverJobsTable). Reuses the same
// API field names as fieldMappings above for standard fields (e.g.
// invoice_number=X, job_id=Y), but range fields use explicit start/end keys
// instead of the old filters[field][$between][0/1] indexing.
// NOTE: invoice_start_date/invoice_end_date confirmed by backend; order/
// delivery start/end keys follow the same naming convention as a guess -
// flag if those need to be different.
const FLAT_RANGE_FIELD_KEYS = {
  orderDate: { startKey: "order_start_date", endKey: "order_end_date" },
  deliveryDate: { startKey: "delivery_start_date", endKey: "delivery_end_date" },
  invoiceDate: { startKey: "invoice_start_date", endKey: "invoice_end_date" },
  deliveredDate: { startKey: "delivered_start_date", endKey: "delivered_end_date" },
};

export const buildFlatFilterParams = (filterData = {}) => {
  const params = new URLSearchParams();

  Object.entries(fieldMappings).forEach(([dataField, [apiField]]) => {
    const value = filterData[dataField];
    if (value !== undefined && value !== null && value !== "") {
      params.append(apiField, value);
    }
  });

  Object.entries(rangeFields).forEach(([rangeKey, { minField, maxField }]) => {
    const { startKey, endKey } = FLAT_RANGE_FIELD_KEYS[rangeKey];
    const min = filterData[minField];
    const max = filterData[maxField];

    if (min !== undefined && min !== null && min !== "") {
      params.append(startKey, min);
    }
    if (max !== undefined && max !== null && max !== "") {
      params.append(endKey, max);
    }
  });

  return params.toString();
};

// Status codes now come straight from the API's orderStatusBlock (see
// OrderCounts.js), and the route segment for every status is just that code
// - so the endpoint is derived directly instead of looked up in a static
// list.
export const resolveOrdersEndpoint = (tabValue, isToday) => {
  const routeSegment = tabValue || "all";
  const baseEndpoint = `delivery/orders/${routeSegment}`;

  if (!isToday) {
    return baseEndpoint;
  }

  return `/delivery/today-orders/${routeSegment}`;
};
